import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  /** A primary action — "Add the first institute", "Clear filters". */
  action?: ReactNode;
  className?: string;
}

/**
 * Shown when a list has nothing in it. Always says what to do next: an empty
 * screen with no action is a dead end.
 */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center gap-3 px-6 py-14 text-center', className)}>
      {icon && (
        <span className="grid h-11 w-11 place-items-center rounded-card bg-surface-2 text-ink-3" aria-hidden>
          {icon}
        </span>
      )}
      <div>
        <p className="text-lg font-[650] text-ink">{title}</p>
        {description && <p className="mt-1 max-w-sm text-sm text-ink-2">{description}</p>}
      </div>
      {action}
    </div>
  );
}
